export const DEFAULT_FLIPT_CONTEXT = {
  user_id: 'anonymous-user',
  board_id: 'anonymous-board',
  network_name: 'anonymous-network'
}
